"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = authorizedFn;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _effects = require("redux-saga/effects");

var _selectors = require("../selectors");

var _actionType = require("../actionType");

var _config = _interopRequireDefault(require("./config"));

var _processTokenRefresh = require("./processTokenRefresh");

var _marked =
/*#__PURE__*/
_regenerator.default.mark(authorizedFn);

function authorizedFn(fn) {
  var processFn, result;
  return _regenerator.default.wrap(function authorizedFn$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          processFn =
          /*#__PURE__*/
          _regenerator.default.mark(function processFn() {
            var tokens, user;
            return _regenerator.default.wrap(function processFn$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    _context.next = 2;
                    return (0, _effects.select)(_selectors.authTokens);

                  case 2:
                    tokens = _context.sent;
                    _context.next = 5;
                    return (0, _effects.select)(_selectors.authUser);

                  case 5:
                    user = _context.sent;
                    _context.next = 8;
                    return (0, _effects.call)(function () {
                      return fn((0, _objectSpread2.default)({}, tokens, {
                        user: user
                      }));
                    });

                  case 8:
                    return _context.abrupt("return", _context.sent);

                  case 9:
                  case "end":
                    return _context.stop();
                }
              }
            }, processFn, this);
          }); // If token refreshing is being processed, wait for it to finish

          _context2.next = 3;
          return (0, _effects.select)(_selectors.isRefreshing);

        case 3:
          if (!_context2.sent) {
            _context2.next = 6;
            break;
          }

          _context2.next = 6;
          return (0, _effects.take)([_actionType.AUTH_REFRESH_TOKEN_FAILURE, _actionType.AUTH_REFRESH_TOKEN_SUCCESS]);

        case 6:
          _context2.prev = 6;
          _context2.next = 9;
          return processFn();

        case 9:
          result = _context2.sent;

          if (!_config.default.detectShouldRefresh(null, result)) {
            _context2.next = 19;
            break;
          }

          _context2.next = 13;
          return (0, _processTokenRefresh.tryToRefreshTokens)();

        case 13:
          _context2.next = 15;
          return (0, _effects.select)(_selectors.isLoggedIn);

        case 15:
          if (!_context2.sent) {
            _context2.next = 19;
            break;
          }

          _context2.next = 18;
          return processFn();

        case 18:
          return _context2.abrupt("return", _context2.sent);

        case 19:
          return _context2.abrupt("return", result);

        case 22:
          _context2.prev = 22;
          _context2.t0 = _context2["catch"](6);

          if (!_config.default.detectShouldRefresh(_context2.t0, null)) {
            _context2.next = 33;
            break;
          }

          _context2.next = 27;
          return (0, _processTokenRefresh.tryToRefreshTokens)();

        case 27:
          _context2.next = 29;
          return (0, _effects.select)(_selectors.isLoggedIn);

        case 29:
          if (!_context2.sent) {
            _context2.next = 33;
            break;
          }

          _context2.next = 32;
          return processFn();

        case 32:
          return _context2.abrupt("return", _context2.sent);

        case 33:
          throw _context2.t0;

        case 34:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked, this, [[6, 22]]);
}